import { service } from "."

export default {
  getAll: () => service.get("/regions/web"),
  getOne: (id) => service.get(`/regions/web/${id}`),
}
